<template>
  <md-snackbar :md-position="position" :md-duration="isInfinity ? Infinity : duration" :md-active.sync="showSnackbar" md-persistent>
    <span>{{message}}</span>
    <md-button class="md-primary" @click="showSnackbar = false">Dismiss</md-button>
  </md-snackbar>
</template>

<script>
  export default {
    props: {
      message:{
        type: String,
        required: true
      },
      duration:{
        type: Number,
        required: true
      },
      showSnackbar:{
        type: Boolean,
        required: true
      },
      position:{
        type: String,
        required: true
      },
      isInfinity:{
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
      }
    },
    computed: {
    },
    created(){
    },
    methods: {
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/snackbar.vue